import React, { ReactElement, useState } from 'react';
import { BaseEntite, BaseEntiteSommaireStatique, BaseEntiteStatique } from '../../../../../common/src/entities';
import ApercuEntiteEnTableHorizontale from './ApercuEntiteEnTableHorizontale';
import ApercuEntiteFromRequest from './ApercuEntiteFromRequest';


export interface PropsDeAprecuEntite<TEntite extends BaseEntite> {
    model: BaseEntiteSommaireStatique<TEntite>,
    entiteRef: TEntite | number
};

export interface IArpercuState<TEntite extends BaseEntite> {
    isLoading: boolean,
    entiteRef: TEntite
};

export default function ApercuEntite<TEntite extends BaseEntite>(props: PropsDeAprecuEntite<TEntite>): ReactElement {
    const {
        model,
        entiteRef,
    } = props;

    const [state, setState] = useState<IArpercuState<TEntite>>({
        isLoading: (typeof entiteRef === "number"),
        entiteRef: entiteRef
    } as IArpercuState<TEntite>);

    let content: ReactElement;
    if (state.isLoading) {
        content = (
            <ApercuEntiteFromRequest
                entite={model as BaseEntiteStatique<TEntite>}
                id={entiteRef as number}
                notifyRequestResponse={(entiteFromResponse: TEntite) => setState({ isLoading: false, entiteRef: entiteFromResponse } as IArpercuState<TEntite>)}
            />
        )
    } else {
        content = (
            <ApercuEntiteEnTableHorizontale 
                model={model as BaseEntiteSommaireStatique<TEntite>}
                entite={state.entiteRef as TEntite}
            />
        )
    }

    return content;
};
